var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"contract-title"},[_vm._v(" "+_vm._s(_vm.text)+" "),_c('div',{staticClass:"img-x",on:{"click":_vm.getRepayment}},[_c('img',{attrs:{"src":require("../assets/image/icons8-x.png")}})])]),_c('div',{staticClass:"wenben"},[_c('loadDetails')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }